import moment from "moment";
import Barcode from "react-barcode";
import logo from "./logo_dark3.png";

const CourierLabel = ({ data, vendor }) => {
  const rec = data?.receiver_details || {};
  const pieces = data?.quote_request_items?.length || 0;
  const tracking_id = data?.job_status_values?.tracking_id || data?.job_token;

  const date = data?.created_at
    ? moment(data.created_at).format("DD-MM-YYYY")
    : "-";

  const totalWeight = data?.quote_request_items?.reduce(
    (sum, item) => sum + (item.actual?.total_weight_KG || 0),
    0
  );

  const totalPrice = Array.isArray(data?.quote_request_items)
    ? data.quote_request_items.reduce(
        (sum, item) => sum + Number(item?.actual?.goods_value || 0),
        0
      )
    : 0;

  return (
    <div className="bill">
      <div className="top-bar">
        <div className="header">
          <div className="logo-header">
            {vendor?.service_type === "OFFLINE" ? (
              <h3 className="mt-4" style={{ fontSize: 16 }}>
                {vendor?.vendor_name || "WORLD2DOOR"}
              </h3>
            ) : (
              <img src={logo} alt="img" />
            )}
          </div>
        </div>
        <div className="barcode">
          <p>AIRWAY BILL NUMBER</p>
          <div className="border-wap">
            <div className="d-flex justify-content-end w-100">
              <Barcode
                value={tracking_id}
                height={40}
                displayValue={true}
                width={1.5}
                fontSize={10}
                margin={0}
              />
            </div>
          </div>
        </div>
      </div>

      <table style={{ lineHeight: "1" }}>
        <tr>
          <td style={{ width: "50%" }}>
            <div
              className="section-title"
              style={{
                fontWeight: "bold",
                display: "flex",
                justifyContent: "space-between",
              }}
            >
              <span>From</span>
            </div>
            <div className="user-data">
              {vendor?.service_type === "OFFLINE" ? (
                <>
                  <div>Name: {vendor.vendor_name || "-"}</div>
                  <div>Phone: {vendor.vendor_contact_number || "-"}</div>
                  <div>Address: {vendor.address || "-"}</div>
                </>
              ) : (
                <>
                  <div>Name: KENS WORLD2DOOR CARGO LLC</div>
                  <div>Phone: 97144468444</div>
                  <div>
                    Address: Suite No. 508, Office No. 24 Dusseldorf Business
                    Point Building, Al Barsha 1
                  </div>
                </>
              )}
            </div>
          </td>
          <td>
            <div
              className="section-title"
              style={{
                fontWeight: "bold",
                display: "flex",
                justifyContent: "space-between",
              }}
            >
              <span>Content </span>
            </div>
            <br />
            <br />
            <br />
          </td>
        </tr>
        <tr>
          <td>
            <div
              className="section-title"
              style={{
                fontWeight: "bold",
                display: "flex",
                justifyContent: "space-between",
              }}
            >
              <span>To</span>
            </div>
            {data?.local_int === "LOCAL" ? (
              <div className="user-data">
                <div>Name: {rec.receiver_name || "-"}</div>
                <div>Area: {rec.area || "-"}</div>
                <div>Phone: {rec.pickup_contact || "-"}</div>
                <div>Address: {rec.address || "-"}</div>
              </div>
            ) : (
              <div className="user-data">
                <div>Name: KENS WORLD2DOOR CARGO LLC</div>
                <div>Phone: 97144468444</div>
                <div>Area: Dusseldorf Business Point Building, Al Barsha 1</div>
                <div>Address: Suite No. 508, Office No. 24</div>
              </div>
            )}

            <br />
            <br />
            <br />
          </td>
          <td>
            <div
              className="section-title"
              style={{
                fontWeight: "bold",
                display: "flex",
                justifyContent: "space-between",
              }}
            >
              <span>Remarks </span>
            </div>
          </td>
        </tr>
      </table>

      <table className="small-table">
        <tr>
          <td>
            <div className="main-box">
              <div className="date">Date</div>
              <div className="date-wap">{date || "-"}</div>
            </div>
          </td>
          <td>
            <div className="main-box">
              <div className="date">City</div>
              <div className="date-wap">{rec.city || "-"}</div>
            </div>
          </td>
          <td>
            <div className="main-box">
              <div className="date">Shipment Value</div>
              <div className="date-wap">{totalPrice}</div>
            </div>
          </td>
        </tr>
        <tr>
          <td>
            <div className="main-box">
              <div className="date">Pieces</div>
              <div className="date-wap">{pieces}</div>
            </div>
          </td>
          <td>
            <div className="main-box">
              <div className="date">Weight</div>
              <div className="date-wap">{totalWeight}</div>
            </div>
          </td>
          <td>
            <div className="main-box">
              <div className="date">Service</div>
              <div className="date-wap">PrePaid </div>
            </div>
          </td>
        </tr>
      </table>
    </div>
  );
};

export default CourierLabel;
